import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/common/app';
import Model from 'flarum/common/Model';
/** Espelha Ramon\Chat\ChannelUser. */
export let NotificationLevel = /*#__PURE__*/function (NotificationLevel) {
  NotificationLevel[NotificationLevel["Never"] = 0] = "Never";
  NotificationLevel[NotificationLevel["Mentions"] = 1] = "Mentions";
  NotificationLevel[NotificationLevel["Always"] = 2] = "Always";
  return NotificationLevel;
}({});

/**
 * Espelha ChannelResource::transferState(). `incoming` é true para quem recebe
 * a oferta; `confirmed` fica false até o dono digitar o código enviado por e-mail.
 */

/**
 * Espelha Ramon\Chat\Rank\RankBook. Nos dois `builtin`, `name` e `color` ficam
 * null até o dono personalizar (tradução padrão e cor do tema). As três cores
 * derivadas são null exatamente quando `color` é.
 */

/**
 * Ranks em ordem de prioridade. `assignments` mapeia id de usuário para ids de
 * ranks personalizados; vazio, o PHP manda `[]`.
 */

export default class Channel extends Model {
  constructor() {
    super(...arguments);
    // ── Identidade ──
    _defineProperty(this, "type", Model.attribute('type'));
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "slug", Model.attribute('slug'));
    _defineProperty(this, "description", Model.attribute('description'));
    _defineProperty(this, "emoji", Model.attribute('emoji'));
    _defineProperty(this, "imageUrl", Model.attribute('imageUrl'));
    _defineProperty(this, "status", Model.attribute('status'));
    _defineProperty(this, "tagId", Model.attribute('tagId'));
    /**
     * Calculado no servidor. Conversas diretas não têm nome salvo e levam o nome
     * dos outros participantes, então é isto que se deve exibir.
     */
    _defineProperty(this, "displayName", Model.attribute('displayName'));
    // ── Configuração ──
    /** Só por convite: fora do Browse e fechado para quem não é membro. */
    _defineProperty(this, "isPrivate", Model.attribute('isPrivate'));
    /** 'all' ou 'moderators'. */
    _defineProperty(this, "postPermission", Model.attribute('postPermission'));
    _defineProperty(this, "threadingEnabled", Model.attribute('threadingEnabled'));
    /** Intervalo mínimo entre mensagens de uma pessoa, em segundos. 0 desliga. */
    _defineProperty(this, "slowModeSeconds", Model.attribute('slowModeSeconds'));
    /**
     * Segundos que este leitor ainda espera. Vem do servidor porque o cliente não
     * sabe, depois de recarregar, quando foi a última mensagem.
     */
    _defineProperty(this, "slowModeRemaining", Model.attribute('slowModeRemaining'));
    _defineProperty(this, "bypassesSlowMode", Model.attribute('bypassesSlowMode'));
    /**
     * Null significa herdar a setting do fórum, não "sem limite"
     * (`Channel::maxMessageLength()` no servidor). Use `resolveMaxMessageLength()`.
     */
    _defineProperty(this, "maxMessageLength", Model.attribute('maxMessageLength'));
    _defineProperty(this, "autoJoin", Model.attribute('autoJoin'));
    /** Inscreve quem responde na categoria vinculada. */
    _defineProperty(this, "autoJoinOnReply", Model.attribute('autoJoinOnReply'));
    /** Anuncia no canal as discussões novas da categoria vinculada. */
    _defineProperty(this, "postDiscussions", Model.attribute('postDiscussions'));
    _defineProperty(this, "allowChannelWideMentions", Model.attribute('allowChannelWideMentions'));
    // ── Contadores ──
    _defineProperty(this, "messagesCount", Model.attribute('messagesCount'));
    _defineProperty(this, "userCount", Model.attribute('userCount'));
    _defineProperty(this, "lastMessageId", Model.attribute('lastMessageId'));
    _defineProperty(this, "lastMessageAt", Model.attribute('lastMessageAt', Model.transformDate));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "archivedAt", Model.attribute('archivedAt', Model.transformDate));
    _defineProperty(this, "archivedDiscussionId", Model.attribute('archivedDiscussionId'));
    // ── Estado do usuário atual ──
    _defineProperty(this, "isFollowing", Model.attribute('isFollowing'));
    /** Convite pendente para o leitor e quem o enviou. */
    _defineProperty(this, "isInvited", Model.attribute('isInvited'));
    _defineProperty(this, "invitedById", Model.attribute('invitedById'));
    _defineProperty(this, "invitedByName", Model.attribute('invitedByName'));
    _defineProperty(this, "isMuted", Model.attribute('isMuted'));
    _defineProperty(this, "notificationLevel", Model.attribute('notificationLevel'));
    _defineProperty(this, "lastReadMessageId", Model.attribute('lastReadMessageId'));
    _defineProperty(this, "unreadCount", Model.attribute('unreadCount'));
    _defineProperty(this, "unreadMentionsCount", Model.attribute('unreadMentionsCount'));
    // ── Permissões ──
    // Usadas direto em `disabled` e visibilidade, para o cliente não oferecer o
    // que o servidor recusaria.
    _defineProperty(this, "canPostMessage", Model.attribute('canPostMessage'));
    _defineProperty(this, "canEdit", Model.attribute('canEdit'));
    _defineProperty(this, "canJoin", Model.attribute('canJoin'));
    /** Entrar sem aparecer na lista de membros; só moderadores. */
    _defineProperty(this, "canJoinHidden", Model.attribute('canJoinHidden'));
    /** Membro invisível. */
    _defineProperty(this, "isHiddenMember", Model.attribute('isHiddenMember'));
    _defineProperty(this, "canClose", Model.attribute('canClose'));
    _defineProperty(this, "canArchive", Model.attribute('canArchive'));
    _defineProperty(this, "canUnarchive", Model.attribute('canUnarchive'));
    _defineProperty(this, "canDelete", Model.attribute('canDelete'));
    _defineProperty(this, "canManageMembers", Model.attribute('canManageMembers'));
    /** O dono ou moderadores do chat. */
    _defineProperty(this, "canManageModerators", Model.attribute('canManageModerators'));
    /** O dono ou um administrador. */
    _defineProperty(this, "canTransferOwnership", Model.attribute('canTransferOwnership'));
    /** Só preenchido quando os participantes são carregados, como `moderatorIds`. */
    _defineProperty(this, "ownershipTransfer", Model.attribute('ownershipTransfer'));
    _defineProperty(this, "creatorId", Model.attribute('creatorId'));
    _defineProperty(this, "canManageRanks", Model.attribute('canManageRanks'));
    /**
     * Ausente na listagem de canais. Leia por `utils/ranks`, que cai no rank que
     * cada mensagem traz.
     */
    _defineProperty(this, "rankBook", Model.attribute('rankBook'));
    /** Moderadores do canal; preenchido quando os participantes são carregados. */
    _defineProperty(this, "moderatorIds", Model.attribute('moderatorIds'));
    _defineProperty(this, "canMentionChannelWide", Model.attribute('canMentionChannelWide'));
    // ── Relações ──
    _defineProperty(this, "creator", Model.hasOne('creator'));
    _defineProperty(this, "lastMessage", Model.hasOne('lastMessage'));
    _defineProperty(this, "participants", Model.hasMany('participants'));
    /** Convites sem resposta; só para quem gerencia membros e quando incluído. */
    _defineProperty(this, "invitedUsers", Model.hasMany('invitedUsers'));
    /**
     * Incluído por padrão na listagem; `participants` só vem quando pedido (aba de
     * membros). Use `others()` em vez das relações direto.
     */
    _defineProperty(this, "directParticipants", Model.hasMany('directParticipants'));
  }
  // ── Derivados ──

  isDirect() {
    return this.type() === 'direct';
  }
  isCategory() {
    return this.type() === 'category';
  }

  /**
   * Quem vê o canal já está nele. Espelha `Channel::isForEveryone()`: a lista de
   * membros só tem quem o administra e a contagem não é a da sala.
   */
  isForEveryone() {
    return this.isCategory() && !!this.autoJoin() && !this.isPrivate();
  }
  isOpen() {
    return this.status() === 'open';
  }
  isClosed() {
    return this.status() === 'closed';
  }
  isArchived() {
    return this.status() === 'archived';
  }

  /** Canal silenciado continua listado, mas sem badge. */
  hasUnread() {
    var _this$unreadCount;
    return !this.isMuted() && ((_this$unreadCount = this.unreadCount()) != null ? _this$unreadCount : 0) > 0;
  }
  hasUnreadMentions() {
    var _this$unreadMentionsC;
    return ((_this$unreadMentionsC = this.unreadMentionsCount()) != null ? _this$unreadMentionsC : 0) > 0;
  }

  /**
   * Todos menos o leitor. `hasMany` devolve `false` para relação não incluída,
   * então tenta `directParticipants` e depois `participants`.
   */
  others() {
    var _app$session$user;
    const loaded = this.directParticipants() || this.participants() || [];
    const actorId = (_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id();
    return loaded.filter(user => Boolean(user) && user.id() !== actorId);
  }
  apiEndpoint() {
    return '/chat-channels' + (this.exists ? '/' + this.id() : '');
  }
}
flarum.reg.add('ramon-chat', 'common/models/Channel', Channel);